/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from './BaseControl.vue';

/**
 * Same as base-select, but collapsible, forked rather than composed b/c we require
 * direct access to vue-multiselect.
 *
 * @category ui.components.form-elements
 * @exports CollapsibleSelect
 * @component
 */
const __vue_script__ = {
    name: 'CollapsibleSelect',

    extends: BaseControl,

    inheritAttrs: false,

    props: {
        // Have to overwrite this here because BaseControl
        // declares one.
        value: {
            type: [Object, Array, String, Number],
            default: null
        },

        optionsLabel: {
            type: String,
            default: 'label'
        },

        startCollapsed: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            collapsed: false,
        };
    },

    computed: {
        // Pass-through listeners
        listeners() {
            // Here we skip the `input` listener, since we provide our own
            // and we don't want it to be overwritten.

            // eslint-disable-next-line
            const { input, open, ...listeners } = this.$listeners;

            return { ...listeners, open: () => this.onOpen(), close: () => this.onClose() };
        },

        // pass-through slots other than noResult slot which is handled locally
        filteredSlots() {
            return Object.entries(this.$scopedSlots)
                /* eslint-disable-next-line no-unused-vars */
                .filter(([name, _]) => name !== 'noResult')
                .reduce((acc, [name, slot]) => ({ ...acc, [name]: slot }), {});
        },

        // Pass-through attributes
        attrs() {
            /* eslint-disable no-unused-vars */

            // Here we remove all the keys that we don't want `multiselect`
            // to inherit from this very component. All other options and attributes
            // are passed through. Basically an underscore.pluck, but since it has been
            // deprecated we are doing it manually.
            const {
                label,
                hint,
                focused,
                optionsLabel,
                value,
                ...attrs
            } = Object.assign(this.$options.propsData, this.$attrs);
            /* eslint-enable no-unused-vars */

            return attrs;
        },
    },

    created() {
        this.collapsed = this.startCollapsed;
    },

    methods: {

        toggle(event) {
            event.preventDefault();
            this.collapsed = !this.collapsed;
        },

        onClick(event) {
            if (this.collapsed) {
                event.preventDefault();
                this.collapsed = false;
            }
        },

        /**
         * Triggered when user interacts with input components.
         *
         * @overwrites BaseControl.input
         *
         * @param {Object} payload the selected payload
         */
        input(payload) {
            this.$emit('input', payload);
        },

        /**
         * Tries to grab the focus on the input element
         */
        attemptFocus() {
            const select = this.$refs.select;

            if (this.focused && select && select.$refs.search) {
                select.$refs.search.focus();
            }
        },

        /**
         * Hook for the opening of the dropdown menu
         */
        onOpen() {
            const ref = this.$refs['select'];
            if (!ref) {
                console.warn('[BaseSelect] Element not in DOM yet.');
                return;
            }

            const inModal = ref.$el.closest('.v--modal') !== null;

            if (inModal) {
                this.calculateMenuPosition(ref);

                const scrollingParent = this.$utils.dom.getScrollParent(ref.$el);
                scrollingParent.addEventListener('scroll', () => this.calculateMenuPosition(ref));
            }
        },

        /**
         * Hook for the closing of the dropdown menu
         */
        onClose() {
            const ref = this.$refs['select'];
            if (!ref) {
                console.warn('[BaseSelect] Element already removed from the DOM.');
                return;
            }

            const scrollingParent = this.$utils.dom.getScrollParent(ref.$el);
            scrollingParent.removeEventListener('scroll', () => this.calculateMenuPosition(ref));
        },

        /**
         * Calculates the correct position of the dropdown menu
         *
         * @param {object} ref the multiselect reference
         */
        calculateMenuPosition(ref) {
            requestAnimationFrame(() => {
                const { top: pTop } = ref.$el.closest('.v--modal').getBoundingClientRect();
                const { top, height, width } = ref.$el.getBoundingClientRect();
                ref.$refs.list.style.width = `${width}px`;
                ref.$refs.list.style.position = 'fixed';
                ref.$refs.list.style.top = `${top + height - pTop}px`;
                ref.$refs.list.style.bottom = 'auto';
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      staticClass: "collapsible-select",
      attrs: {
        dependant: _vm.dependant,
        label: _vm.label,
        tip: _vm.tip,
        hint: _vm.hint,
        uid: _vm.uid,
        errors: _vm.errors,
        hintAfterLabel: _vm.hintAfterLabel,
        warning: _vm.warning,
      },
      on: { click: _vm.onClick },
      scopedSlots: _vm._u(
        [
          {
            key: "inside-label",
            fn: function (ref) {
              return [_vm._t("inside-label")]
            },
          },
          {
            key: "after-label",
            fn: function (ref) {
              return [_vm._t("after-label")]
            },
          },
        ],
        null,
        true
      ),
    },
    [
      _c(
        "multiselect",
        _vm._g(
          _vm._b(
            {
              ref: "select",
              staticClass: "form-control",
              class: {
                "has-error": _vm.errors.length,
                "has-warning": _vm.warning,
                collapsed: _vm.collapsed,
              },
              attrs: { value: _vm.value, id: _vm.uid, label: _vm.optionsLabel },
              on: { input: _vm.input },
              scopedSlots: _vm._u(
                [
                  {
                    key: "caret",
                    fn: function (ref) {
                      return [
                        _c("div", { staticClass: "collapsed-count" }, [
                          _c("div", { staticClass: "multiselect__tag" }, [
                            _vm._v(_vm._s(_vm.value.length)),
                          ]),
                        ]),
                        _c("div", { staticClass: "toggler" }, [
                          _c("i", {
                            staticClass: "ic-chevron-up",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.toggle.apply(null, arguments)
                              },
                            },
                          }),
                        ]),
                      ]
                    },
                  },
                  _vm._l(_vm.filteredSlots, function (_, scopedSlot) {
                    return {
                      key: scopedSlot,
                      fn: function (scope) {
                        return [_vm._t(scopedSlot, null, null, scope)]
                      },
                    }
                  }),
                ],
                null,
                true
              ),
            },
            "multiselect",
            _vm.attrs,
            false
          ),
          _vm.listeners
        ),
        [
          _c("template", { slot: "noResult" }, [
            _vm._v(_vm._s(_vm.$t("general.no_elements"))),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/CollapsibleSelect.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__